import * as ROUTES from '../backend-routes'
import { executePut } from '../requests/axios'

export const sendOTP = function (username, recaptchaToken, onSuccess, onError) {
  const payload = JSON.stringify({ username: username, recaptchaToken: recaptchaToken })

  executePut(ROUTES.LOGIN.PATH_OTP, payload, onSuccess, onError)
}

export const sendUsernameConfirmation = function (username, recaptchaToken, onSuccess, onError) {
  const payload = JSON.stringify({ username: username, recaptchaToken: recaptchaToken })

  executePut(ROUTES.REGISTER.PATH_SEND_CONFIRM_USERNAME, payload, onSuccess, onError)
}

export const sendPasswordReset = function (username, operation, onSuccess, onError) {
  sendCode(ROUTES.LOGIN.PATH_PASSWORD, username, operation, onSuccess, onError)
}

function sendCode (path, username, operation, onSuccess, onError) {
  const payload = JSON.stringify({ username: username, operation: operation })

  executePut(path, payload, onSuccess, onError)
}
